import { Component, OnInit } from '@angular/core';
import { BaseListComponent } from '../../../../shared/base/base-list.component'
import { BooleanFields, RouteAuthorities, ValueLabel } from 'src/app/shared/base/base.models';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { HttpRequestType, RequestService } from '../../../../core/request.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/app/app.constants';
import { UserType, UserTypeNotSystemEnum } from '../users.models';
import { UsersService } from '../users.service';
import { Role } from '../../roles/roles.models'

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent extends BaseListComponent implements OnInit {
  public gridStateKey: string = 'users_list_grid_state';
  public lookupColumns: Array<string> = ['name', 'login', 'email', 'userType'];

  public userTypes: ValueLabel[] = [];
  public rolesLookUp: Role[] = [];
  public isCurrentUserSystem: boolean = false;
  public statuses: ValueLabel[] = [];

  constructor(
    public usersService: UsersService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public baseService: BaseService,
    public dialogService: DialogService,
    public alertService: AlertService,
    public utilityService: UtilityService,
    public requestService: RequestService,
    public translateService: TranslateService
  ) {
    super(authService, loadingService, baseService, dialogService, alertService, utilityService, requestService, translateService);
    this.authorities = new RouteAuthorities(authService, alertService, 'C_USR', 'R_USR', 'U_USR', null);
    this.creatable = this.authorities.create;
    this.editable = this.authorities.update;
    this.deletable = this.authorities.delete;
    this.activatable = this.authorities.update;
  }

  ngOnInit(): void {
    this.url = `${Constants.contextPath}/users`;
    this.prepareLookupData();
    this.getGridData();
  }

  private prepareLookupData() {
    this.rolesLookUp = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(Role, false), 'value', 'value');
    this.isCurrentUserSystem = this.authService.userType == UserType[UserType.SYSTEM];
    this.statuses = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(BooleanFields, true), 'value', 'label', 'ENUMS.ACTIVE_FIELDS.');


    if (!this.isCurrentUserSystem) {
      this.userTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(UserTypeNotSystemEnum, true), 'value', 'label', 'ENUMS.USER_TYPES.');
    } else {
      this.userTypes = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(UserType, true), 'value', 'label', 'ENUMS.USER_TYPES.')
        .filter(u => u.value != UserType[UserType.CLIENT_PUBLIC]);
    }
  }

  public changeStatusForUser(id: string, active: boolean) {
    if (id != this.authService.userId)
      this.changeStatus(id, active);
  }

  public loadGridState = (): any => {
    return this.loadGridStateBase(this.gridStateKey, this.lookupColumns);
  }

  public saveGridState = (state: any): void => {
    this.saveGridStateBase(state, this.gridStateKey, this.lookupColumns);
  }

  resetLoginAttempts(id: string) {
    this.usersService.resetFailedLoginAttempts(id, () => {
      this.alertService.success('USERS.RESET_FAILED_LOGIN_ATTEMPTS_SUCCESS');
    })
  }

  exportToCSV() {
    this.usersService.exportToCSV((res: any) => {
      const a = document.createElement('a')
      const objectUrl = URL.createObjectURL(res)
      a.href = objectUrl
      a.download = `${'users'}.xls`;
      a.click();
      URL.revokeObjectURL(objectUrl);
    })
  }
  // public getGridData() {
  //   this.dataSource = this.usersService.getUsersByRole(this.authService.roles[0]).store;
  // }
}